// =====================================================================
// Marketing pages ab shop.kridemy.com (website) pe hain.
// App ke purane URLs (/, /about, /for-teacher ...) yahan redirect hote hain.
// Shop pe naya page / URL badle to sirf yahi file badlo.
// =====================================================================

export const SHOP_URL = "https://shop.kridemy.com";

export const SHOP_PAGES = {
    home: `${SHOP_URL}/`,
    about: `${SHOP_URL}/about-us/`,
    forTeachers: `${SHOP_URL}/for-teachers/`,
    studentsParents: `${SHOP_URL}/students-parent/`,
};
